import { DataTable } from "@components/ui/data-table/DataTable";
import { ROUTES } from "@features/rh/config/constants";
import { congesRequestsColumns } from "@features/rh/conges/config/columns";
import { Link } from "@tanstack/react-router";
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { FileText } from "lucide-react";
import { useState } from "react";
import type { LeaveRequest } from "../types";

interface CongesRequestsTableProps {
  requests?: LeaveRequest[];
}

export function CongesRequestsTable({ requests = [] }: CongesRequestsTableProps) {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const table = useReactTable({
    data: requests,
    columns: congesRequestsColumns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
  });

  return (
    <div className="card bg-base-200 border border-base-300/60 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 animate-fade-in">
      <div className="card-body p-0">
        {/* Header with icon */}
        <div className="flex justify-between items-center p-6 border-b border-base-200/60 bg-base-100/30">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
              <FileText className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h2 className="card-title text-xl mb-0.5">Mes Demandes</h2>
              <p className="text-sm text-base-content/50">
                {requests.length} demande{requests.length !== 1 ? "s" : ""}
              </p>
            </div>
          </div>
          <Link to={ROUTES.RH.CONGES.NEW_REQUEST} className="btn btn-primary">
            Nouvelle Demande
          </Link>
        </div>
        <div className="p-6">
          <DataTable table={table} columns={congesRequestsColumns} renderExpandedRow={undefined} />
        </div>
      </div>
    </div>
  );
}
